<template>
  <div class="aiChat">
    <div class="aiChat__header">
      <div class="aiChat__title">AI Chat History</div>
    </div>

    <div class="aiChat__filters">
      <input
        v-model="prompt"
        type="text"
        placeholder="Prompt"
        @keyup.enter="search"
      />

      <input
        v-model="userName"
        type="text"
        placeholder="User"
        @keyup.enter="search"
      />

      <div class="aiChat__button"  @click="search">
        <span class="text">Search</span>
      </div>
    </div>

    <div class="aiChat__table-wrapper">
        <div
            v-if="loading"
            class="aiChat__loading"
            >
            Loading...
        </div>

        <div
            v-if="!loading && !history.length"
            class="aiChat__empty"
            >
            No AI chat history yet.
        </div>

        <AiChatHistoryTable
            v-show="history.length"
            :dataList="history"
            :rowCount="historyCount"
            :pageCount="historyPageCount"
            @pageClick="onPageClick"
        />
    </div>
  </div>
</template>

<script>
import AiChatHistoryTable from '@/components/dashboard/AiChatHistoryTable/AiChatHistoryTable'

export default {
  name: 'AiChat',

  data: () => ({
    prompt: '',
    userName: '',
    loading: false,
  }),

  computed: {
    history () {
      return this.$store.state.adminAiChat.history
    },

    historyCount () {
      return this.$store.state.adminAiChat.historyCount
    },

    historyPageCount () {
      return this.$store.state.adminAiChat.historyPageCount
    },
  },

  created () {
    this.loadHistory({
      pageNumber: 1,
      pageSize: 20,
    })
  },

  methods: {
    async loadHistory (data) {
      this.loading = true

      try {
        await this.$store.dispatch('getAdminAiChatHistory', {
          ...data,
          prompt: this.prompt,
          userName: this.userName,
        })
      } catch (e) {
        console.log(e)
      }

      this.loading = false
    },

    async onPageClick (data) {
      await this.loadHistory(data)
    },

    async search () {
      await this.loadHistory({
        pageNumber: 1,
        pageSize: 20,
      })
    },
  },

  components: {
    AiChatHistoryTable,
  },
}
</script>

<style lang="stylus" scoped>
@import './AiChat.styl'
</style>